module.exports = __webpack_public_path__ + "static/main-harimau-banner-6fca0a33129a12c85bb1aafb0602b8cd.jpg";